"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const offline_query_resolver_1 = __importDefault(require("./offline-query-resolver"));
const i18nPointsFormat_1 = require("@amzn/i18n-points-format-typescript/dist/i18nPointsFormat");
const i18n_configuration_provider_1 = require("@amzn/i18n.configuration-provider");
const documents_json_1 = require("@amzn/i18n-points-format-config/dist/acs_I18nPointsFormat/documents.json");
const queries_json_1 = require("@amzn/i18n-points-format-config/dist/acs_I18nPointsFormat/queries.json");
const hierarchical_queries_json_1 = require("@amzn/i18n-points-format-config/dist/acs_I18nPointsFormat/hierarchical_queries.json");
/**
 * Resolves queries using the I18nPointsFormat feature
 * (https://console.harmony.a2z.com/acs-web-editor/features/I18nPointsFormat).
 */
class PointsFormatQueryResolver extends offline_query_resolver_1.default {
    resolve(attributeName, args) {
        super.validate(attributeName, args);
        return this.doResolve(attributeName, args);
    }
    doResolve(attributeName, args) {
        const context = new i18nPointsFormat_1.I18nPointsFormatContext(super.createAcsContextInput(args.locale), super.createAcsContextInput(args.programName), super.createAcsContextInput(args.style));
        const configBuilder = new i18n_configuration_provider_1.I18nConfiguration.Builder();
        switch (attributeName) {
            case i18n_configuration_provider_1.PointsFormat.PATTERN:
                const pattern = this.getAcsClient().getPattern(context);
                configBuilder.addConfiguration(i18n_configuration_provider_1.PointsFormatResult.PATTERN, pattern);
                break;
            default:
                throw new Error(`Attribute name ${attributeName} is not defined for feature ${attributeName.getConfigType()}`);
        }
        return configBuilder.build();
    }
    getAcsClient() {
        return super.acsClient;
    }
    getTypeSafeClientProvider() {
        return new i18nPointsFormat_1.I18nPointsFormatClientProvider();
    }
    getOfflineConfigFiles() {
        return {
            documents: documents_json_1.documents,
            exactQueries: queries_json_1.queries,
            hierarchicalFallbackQueries: hierarchical_queries_json_1.queries
        };
    }
    getTargetConfigType() {
        return PointsFormatQueryResolver.CONFIG_TYPE;
    }
    getValidationErrorMessage() {
        return `Points format can only be resolved for configType ${PointsFormatQueryResolver.CONFIG_TYPE}`;
    }
}
exports.default = PointsFormatQueryResolver;
PointsFormatQueryResolver.CONFIG_TYPE = i18n_configuration_provider_1.ConfigType.POINTS_FORMAT;
//# sourceMappingURL=points-format-query-resolver.js.map